module.exports = __webpack_public_path__ + "img/Share of Search.ab96bdf8.svg";